import {GET_ALL_PACKAGES} from "../../Config/ApiUrl";
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";

export default {
    // mixins: [],
    mixins: [HelperMixin, DatatableHelperMixin],
    data() {
        return {
            isLocationModalActive: false,
            isLocationCreateOpenModalActive: false,
            selectedUrl: '',
            promptIcon: '',
            employeeId: '',
            modalClass: '',
            isModalActive: false,
            options: {
                showSearch: true,
                showFilter: true,
                cardViewComponent: 'app-package-card-view',
                name: this.$allLabel('packages'),
                url: GET_ALL_PACKAGES,
                showCount: true,
                showClearFilter: true,
                responsive: true,
                showAction: true,
                actionType: "default",
                enableRowSelect: false,
                columns: [
                    {
                        title: this.$t('package'),
                        type: 'custom-html',
                        key: 'name',
                        isVisible: true,
                        modifier: (name) => {
                            return name ? name: '-';
                        }
                    },
                    {
                        title: this.$t('price'),
                        type: 'custom-html',
                        key: 'price',
                        isVisible: true,
                        modifier: (price) => {
                            return price ?? '-';
                        }
                    },
                    {
                        title: this.$t('user_limit'),
                        type: 'custom-html',
                        key: 'user_limit',
                        isVisible: true,
                        modifier: (user_limit) => {
                            return user_limit ?? '-';
                        }
                    },
                    {
                        title: this.$t('location_limit'),
                        type: 'custom-html',
                        key: 'location_limit',
                        isVisible: true,
                        modifier: (location_limit) => {
                            return location_limit ?? '-';
                        }
                    },
                    {
                        title: this.$t('billing_cycle'),
                        type: 'custom-html',
                        key: 'billing_cycle',
                        isVisible: true,
                        modifier: (billing_cycle) => `<span class="text-capitalize">${billing_cycle}</span>`
                    },
                    // {
                    //     title: this.$t('duration'),
                    //     type: 'custom-html',
                    //     key: 'duration',
                    //     isVisible: true,
                    //     modifier: (duration) => duration ? `<span class="text-capitalize">${duration}</span> months` : ''
                    // },
                    {
                        title: this.$t('modules'),
                        type: 'custom-html',
                        key: 'modules',
                        isVisible: true,
                        modifier: (modules) => modules ? `<span class="text-capitalize">${modules.join(', ')}</span>` : ''
                    },
                    {
                        title: this.$t('trial_period_default'),
                        type: 'custom-html',
                        key: 'trial_period',
                        isVisible: true,
                        modifier: (trial_period) => trial_period !== null ? `<span class="text-capitalize">${trial_period}</span>` : ''
                    },
                    {
                        title: this.$t('featured'),
                        type: 'custom-html',
                        key: 'featured',
                        isVisible: true,
                        modifier: (featured) => featured === 'yes' ? `<i class="fa fa-check-circle text-success"></i>` : ''
                    },
                    {
                        title: this.$t('status'),
                        type: 'custom-html',
                        key: 'status',
                        isVisible: true,
                        modifier: status => {
                            return `<span class="badge badge-pill text-capitalize text-${status === 'active' ? 'success' : 'danger'} badge-${status === 'active' ? 'active' : 'inactive'}">
                                ${status}
                            </span>`
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                rowLimit: 10,
                paginationType: "pagination",
                actions: [
                    {
                        title: this.$t('edit'),
                        // url: GET_ALL_LOCATIONS,
                        icon: 'edit',
                        key: "edit",
                        modifier: row => {
                            return this.$can('update_packages') && (row.id !== window.user.id || this.$isAdmin());
                        },
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash-2',
                        url: GET_ALL_PACKAGES,
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'app-confirmation-modal',
                        name: 'delete',
                        modifier: row => {
                            return this.$can('delete_packages') && (row.id !== window.user.id || this.$isAdmin());
                        },
                    }
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "created_at",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title: this.$t('name'),
                        key: "name",
                        type: "text",
                    },
                ]
            },
            selectedEmployees: [],
            isContextMenuOpen: false,
        }
    },
    methods: {
        openLocationModal() {
            this.isLocationModalActive = true;
        },
        setFilterValues(filterValue) {
            if (filterValue.date_range && typeof filterValue.date_range != 'string') {
                filterValue.date_range = JSON.stringify(filterValue.date_range)
            }
            this.$store.dispatch('updateFilterObject', filterValue)
        },
        setSearchValue(search) {
            this.$store.dispatch('updateFilterObject', {search: search})
        },
        getSelectedRows(data, isSelectedAll) {
            this.selectedEmployees = data;
            this.isContextMenuOpen = data.length;
        },
        triggerActions(row, action, active) {


            // if (action.key === 'view_details') {
            //     window.location = urlGenerator(`${EMPLOYEES_PROFILE}/${this.employeeId}/profile`);
            // }

            console.log(action.key);
            if (action.key === 'edit') {
                // this.promptIcon = action.icon;
                // this.employeeId = row.id;
                // this.modalClass = action.modalClass;
                // console.log(row, action);
                // this.selectedUrl = `${action.url}/${row.id}`;
                // this.isModalActive = true;
                // this.promptIcon = action.icon;
                // this.employeeId = row.id;
                // this.modalClass = action.modalClass;
            }

        },
    }
}